import { matchRoutes } from 'react-router-config';

export function ensureReady(routeConfig, providedLocation) {
  const matches = matchRoutes(routeConfig, providedLocation || location.pathname);
  return Promise.all(matches.map((match) => {
    const { component } = match.route;
    if (component && component.load) {
      return component.load();
    }
    return undefined;
  }));
}


// WEBPACK FOOTER //
// ./src/helpers/ensureReady.js